/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Permission_See_All_Chats_Hint_AdminInputs */



/**
* | output |
* | --- |
* | "Project admins always see everyone's chats." |
*
* @param {Projects_Permission_See_All_Chats_Hint_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_permission_see_all_chats_hint_admin = /** @type {((inputs?: Projects_Permission_See_All_Chats_Hint_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Permission_See_All_Chats_Hint_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt-Admins sehen immer die Chats aller Mitglieder.")
	return /** @type {LocalizedString} */ ("Project admins always see everyone's chats.")
});